import 'bootstrap/dist/css/bootstrap.min.css';
import './src/styles/external/flaticon.css';
import 'boxicons/css/boxicons.min.css';
import 'react-modal-video/css/modal-video.min.css';
import 'react-accessible-accordion/dist/fancy-example.css';
import './src/styles/base.scss';
import './src/styles/responsive.scss';

import wrapWithProvider from './wrap-with-provider';
import Amplify from 'aws-amplify';
import awsConfig from './src/aws-exports';
Amplify.configure(awsConfig);

export const wrapRootElement = wrapWithProvider;

export const onServiceWorkerUpdateReady = () => {
  const prompt = window.confirm(
    `A content change has been pushed to Hop In. Reload to display the latest version?`
  );
  if (prompt) {
    window.location.reload();
  }
};
